export const MOBILE_HEADER_NAV_CLOSE = 'mobile-header-nav-close';

export const getMobileHeaderNavCloseButton = () => document.getElementById(MOBILE_HEADER_NAV_CLOSE);
